import { Link, useGetIdentity, usePermissions, useTranslate, useUserMenu } from "react-admin"
import { MenuItem, ListItemIcon, ListItemText, Rating } from "@mui/material"
import { WorkspacePremium } from "@mui/icons-material"
import { Permissions } from "../../authentication/Permissions"
import getSubscriptionInfo from "../../users/subscriptions/getSubscriptionInfo"
import { useEffect } from "react"

const SubscriptionMenuItem = () => {

  const { onClose } = useUserMenu()
  const translate = useTranslate()
  const {isLoading: isLoadingPermissions, permissions, refetch} = usePermissions<Permissions>()
  const {isLoading: isLoadingIdentity, data: identity } = useGetIdentity()
  const subscriptionInfo = getSubscriptionInfo(permissions?.activeSubscriptions)

  useEffect(() => {
    refetch()
  }, [])

  if(isLoadingPermissions || isLoadingIdentity || !identity) return null

  return (
    <MenuItem
      component={Link}
      to={`/users/${identity.id}/show`}
      onClick={onClose}
    >
      <ListItemIcon>
        <WorkspacePremium />
      </ListItemIcon>      
      <ListItemText>
        {
          subscriptionInfo
          ? <>
              {`${translate('resources.users.menu.subscription')}: ${subscriptionInfo?.name}`}
              <Rating sx={{ml:1}} readOnly value={subscriptionInfo?.rating} max={3} />
            </> 
          : <>{translate('resources.users.menu.subscription')}</>
        }
      </ListItemText>
    </MenuItem>
  )
}

export default SubscriptionMenuItem